import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Sun, Moon, Languages } from 'lucide-react';

const Layout = () => {
  const [darkMode, setDarkMode] = useState(false);
  const { language, toggleLanguage, t } = useLanguage();
  const navigate = useNavigate();
  
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.documentElement.classList.toggle('dark');
  };
  
  return (
    <div className={`min-h-screen ${darkMode ? 'dark' : ''}`}>
      <div className="min-h-screen bg-white dark:from-slate-900 dark:via-slate-800 dark:to-slate-900">
        {/* Header */}
        <header className="sticky top-0 z-50 bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700">
          <div className="container mx-auto px-6 py-5">
            <div className="flex items-center justify-between">
              <div 
                className="flex items-center space-x-4 cursor-pointer"
                onClick={() => navigate('/')}
              >
                <div className="w-10 h-10 bg-[#2d3748] dark:bg-white rounded-sm flex items-center justify-center">
                  <span className="text-white dark:text-[#2d3748] font-bold text-lg tracking-tighter">BP</span>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-[#1f2937] dark:text-white tracking-tight">
                    BUILDPLAN
                  </h1>
                  <p className="text-xs text-slate-500 dark:text-slate-400 uppercase tracking-wide">Project Management</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-2">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={toggleLanguage}
                  data-testid="language-toggle"
                >
                  <Languages className="h-5 w-5" />
                  <span className="ml-1 text-xs">{language.toUpperCase()}</span>
                </Button>
                
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={toggleDarkMode}
                  data-testid="theme-toggle"
                >
                  {darkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
                </Button>
              </div>
            </div>
          </div>
        </header>
        
        {/* Main Content */}
        <main className="container mx-auto px-6 py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;